<template>
  <div class="w-full mb-5">
    <h3 class="Label mb-4">What is your motivation to join with us?</h3>

    <div class="flex flex-wrap justify-content-center gap-3">
      <div
        v-for="option in registrationGoals"
        :key="option.value"
        class="pill-option cursor-pointer"
        :class="{ 'pill-option-selected': selectedValues.includes(option.value) }"
        @click="toggleOption(option.value)"
      >
        <div class="flex align-items-center gap-2">
          <i class="pi" :class="selectedValues.includes(option.value) ? 'pi-check' : 'pi-plus'"></i>
          <span class="Paragraph-Regular">{{ option.label }}</span>
        </div>
      </div>
    </div>

    <Button label="Next" class="orange-button mt-6" @click="nextStep" />
  </div>
</template>

<script setup>
import { ref, defineEmits } from "vue";
import { registrationGoals } from "@/utils/options";
import Button from 'primevue/button';
import { notifyWarn } from "@/utils/notification";

const emit = defineEmits(["motivations-selected"]);
const selectedValues = ref([]);

const toggleOption = (value) => {
  const index = selectedValues.value.indexOf(value);
  if (index > -1) {
    selectedValues.value.splice(index, 1);
  } else {
    selectedValues.value.push(value);
  }
};

const nextStep = () => {
  if(selectedValues.value.length === 0){
    notifyWarn("Please select at least one option");
    return
  }
  emit("motivations-selected", [...selectedValues.value]);
};
</script>

<style scoped>
.Paragraph-Regular {
  color: var(--orange-500);
}

.pill-option {
  padding: 8px 16px;
  border: 2px solid var(--gray-300);
  border-radius: 50px;
  background: white;
  transition: all 0.3s ease;
  min-width: 200px;
  text-align: center;
  user-select: none;
}

.pill-option:hover {
  border-color: var(--orange-600);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(99, 102, 241, 0.2);
}

.pill-option-selected {
  border-color: var(--orange-500);
  background: var(--orange-500);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.3);
}

.pill-option-selected .Paragraph-Regular,
.pill-option-selected .pi {
  color: white;
}

.pill-option:not(.pill-option-selected) .pi {
  color: var(--orange-500);
}

@media (max-width: 768px) {
  .pill-option {
    min-width: 150px;
    padding: 0.6rem 1.2rem;
  }
}
</style>
